/*
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2024, Zumper
 */

import { LIST_ITEM_CLICK } from '@zcode-ui/web-zumper-integrations'
import type { TopListable } from '@zcode/bizos'
import * as Optimizely from '@zcode/nr/es/shared/packages/optimizely-middleware'
import { CLICK_LIST_CARD } from '@zcode/nr/es/shared/thirdParty/optimizely/constants'
import type { Listable, Pin, Property, RawPinInventorySearch } from '@zcode/state-type'
import type { Dispatch } from 'redux'
import { mixpanelMaplistClick } from '../../mixpanel/thunks/mixpanelMaplistClick'
import { trackListItemEvent } from '../../traktor/thunks'

interface Props {
  section?: 'Listing Card' | 'Explore nearby rentals by lifestyle'
  entity?: Listable | Pin<RawPinInventorySearch> | Property | TopListable | null
  additionalProps?: { [key: string]: unknown }
}

export const trackListCardClick =
  ({ entity, additionalProps, section = 'Listing Card' }: Props) =>
  (dispatch: Dispatch) => {
    dispatch(trackListItemEvent({ name: LIST_ITEM_CLICK, entity, additionalProps }))
    dispatch(mixpanelMaplistClick({ entity, section, buttonClicked: 'View Detail' }))
    dispatch(Optimizely.track({ eventKey: CLICK_LIST_CARD }))
  }
